// Création de l'objet à envoyer au back pour le responsable légal
const formaterCreationResponsableLegal = async (dataForm, uuidBrouillon, champFichier = null) => {
    const objetFormatte = {
        uuidBrouillon,
        dateNaissance: dataForm.dateNaissance,
        dateDelivrance: dataForm.dateDelivrance,
        lieuNaissance: dataForm.lieuNaissance,
        idNationalite: dataForm.nationalite,
        idPaysNaissance: dataForm.paysNaissance ? dataForm.paysNaissance : 75,
        nom: dataForm.nom,
        nomUsage: dataForm.nomUsage ? dataForm.nomUsage : dataForm.nom,
        prenomUn: dataForm.prenomUn,
        prenomDeux: dataForm.prenomDeux ? dataForm.prenomDeux : null,
        prenomTrois: dataForm.prenomTrois ? dataForm.prenomTrois : null,
        prenomQuatre: dataForm.prenomQuatre ? dataForm.prenomQuatre : null,
        prenomUsuel: dataForm.prenomUsuel ? dataForm.prenomUsuel : dataForm.prenomUn,
        sexe: dataForm.sexe,
        numeroPieceIdentite: dataForm.numeroPieceIdentite,
        typePieceIdentite: dataForm.typePieceIdentite,
    };

    if (champFichier && dataForm[champFichier]) {
        objetFormatte[champFichier] = dataForm[champFichier];
    }

    return objetFormatte;
};

export default formaterCreationResponsableLegal;
